import { classNames } from 'shared/lib/classNames/classNames'
import cls from './Menu.module.scss'
import { Text, TextAlign, TextSize, TextWeight } from 'shared/ui/Text/Text'
import { CloseIcon, PinIcon, UnpinIcon } from 'shared/ui/Icon'

export const Menu = (props) => {
    const {
        className,
        isPinned,
        fromPinnedMoment,
        toPinnedMoment,
        toRejectedMoment,
        onCloseSettings,
        cardId,
        style,
    } = props

    return (
        <div className={classNames(cls.Menu, {}, [className])}>
            <div
                className={cls.background}
                onMouseDown={onCloseSettings}
                onTouchStart={onCloseSettings}
            />
            <div style={style} className={cls.Wrapper}>
                <div
                    onClick={() => {
                        if (isPinned) {
                            onCloseSettings()
                            fromPinnedMoment(cardId)
                        } else {
                            onCloseSettings()
                            toPinnedMoment(cardId)
                        }
                    }}
                    className={cls.item}
                >
                    <Text
                        className={cls.text}
                        size={TextSize.S}
                        align={TextAlign.LEFT}
                        weight={TextWeight.SBOLD}
                    >
                        {isPinned ? 'Открепить' : 'Закрепить'}
                    </Text>
                    {isPinned ? (
                        <UnpinIcon className={cls.icon} />
                    ) : (
                        <PinIcon className={cls.icon} />
                    )}
                </div>
                <div className={cls.line} />
                <div
                    onClick={() => {
                        onCloseSettings()
                        toRejectedMoment(cardId)
                        // console.log(cardId)
                    }}
                    className={cls.item}
                >
                    <Text
                        className={cls.text}
                        size={TextSize.S}
                        align={TextAlign.LEFT}
                        weight={TextWeight.SBOLD}
                    >
                        Неинтересно
                    </Text>
                    <CloseIcon className={cls.icon} />
                </div>
            </div>
        </div>
    )
}
